/* globals Class */
var h             = require('virtual-dom/h');
var createElement = require('virtual-dom/create-element');
var jQuery        = require('jquery');

var BaseDialog = require('./base_dialog');

var render = function(mainPage, contentType, showUrl) {
  var urlClassName = '.publish-url' + (mainPage.wordpressEnabled ? '.wordpress-enabled' : '');
  var publishUrl   = mainPage.page.published_url || '';

  var header;
  var headerClass = '';
  if (showUrl) {
    header = h('.modal-header', [
      h('.publish-sublabel', ['Your ', contentType, ' URL:']),
      h(urlClassName, publishUrl.replace('http://', ''))
    ]);
    headerClass = '.modal-content-container-with-header';
  }

  var republishTip = h('.modal-panel-description', [
    h('.heads-up-icon .svg-ico-lightbulb'),
    h('p .publish-copy', [
      h('span .publish-label', 'Heads up! '),
      'Republishing will push all the changes you\'ve ',
      'made on any of your ',
      'variants to your live ',
      contentType.toLowerCase(),
      '.'
    ])
  ]);

  return createElement(
    h('.modal-content-container.publish-url-content-container' + headerClass, [
      header,
      republishTip
    ])
  );
};

var ReadyToRepublishDialog = Class.create(BaseDialog, {

  initialize: function($super, options) {
    this.mainPage = options.mainPage;
    this.contentType = options.contentType;
    this.showUrl = options.showUrl;

    var editorUIBinding = options.editorUIBinding;

    var self = this;

    options = {
      attributes: {
        className: 'modal-panel modal-panel-ready-to-publish' + (this.showUrl ? '' : ' no-url')
      },
      allowHeader: true,
      closeX: true,
      actions: [
        {
          id: 'dismiss',
          attributes: {
            id: 'dismiss',
            class: 'bug-me-not form-elm checkbox-input'
          },
          type: 'checkbox',
          label: 'Don\'t show me this again'
        },
        {
          attributes: {
            id: 'cancel',
            className: 'button modal-button'
          },
          type: 'button',
          label: 'Cancel',
          action: function() {
            self.close();
          }
        },
        {
          attributes: {
            id: 'publish',
            className: 'button modal-button action'
          },
          type: 'button',
          label: 'Republish',
          action: function(ev) {
            var $button = jQuery(ev.source.e);
            if ($button.hasClass('loading')) { return; }

            $button.addClass('loading');
            editorUIBinding.onNext({type:'requestRepublish'});

            if (localStorage) {
              // Value will be a string - either "true" or "false"
              var dismissValue = String(self.actionButtons.dismiss.getValue());
              localStorage.setItem('dismissPublishConfirmation', dismissValue);
            }
          }
        }
      ]
    };

    $super(options);
  },

  installUI: function($super) {
    $super();

    this.setTitle('Save & republish all variants of this ' + this.contentType.toLowerCase());
    this.setContent(render(this.mainPage, this.contentType, this.showUrl));
  }

});

module.exports = ReadyToRepublishDialog;



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/publish/ready_to_republish.js